<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>User - {{this.subTitle}}</h2>
			</b-col>
			<!--Gear Icon-->
			<b-col v-if="role !== 'operations_manager'"  lg="6">
				<!-- <b-btn class="pull-right" v-b-popover.hover.top="'Select Datapoints'" variant="info" @click="configTable = true"><i class="fa fa-cog"></i></b-btn> -->
				<b-dropdown :disabled="edit" class="pull-right ml-1" right variant="info" no-caret>
					<template slot="button-content">
							<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editUser">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteUser">Delete</b-dropdown-item>
				</b-dropdown>
				<b-btn v-if="role !='analyst'" class="pull-right" variant="info" @click="resend()"><i class="fa fa-send"></i></b-btn>
			</b-col>
			<b-col v-else lg="6"  >
				<b-container v-if="current_user_role_name === 'analyst' || current_user_role_name === 'super_analyst' || current_user_role_name === 'marketing_accountant'">
				<!-- <b-btn class="pull-right" v-b-popover.hover.top="'Select Datapoints'" variant="info" @click="configTable = true"><i class="fa fa-cog"></i></b-btn> -->
				<b-dropdown :disabled="edit" class="pull-right ml-1" right variant="info" no-caret>
					<template slot="button-content">
							<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editUser">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteUser">Delete</b-dropdown-item>
				</b-dropdown>
				</b-container>
				<b-btn v-if="role !='analyst' || role != 'marketing_accountant'" class="pull-right" variant="info" @click="resend()"><i class="fa fa-send"></i></b-btn>
			</b-col>
		</div>
		<div>
			<b-card v-if="loadingData">
				<b-col cols="12" sm="12" md="12" lg="12">
					<p class="text-center">
						<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
					</p>
				</b-col>
			</b-card>
			<div v-else>
				<b-card v-if="found">
						<b-tabs pills card v-if="(user_role_id == 2 && loggued_user_rol == 1) || (user_role_id == 2 && loggued_user_rol == 4) || (user_role_id == 2 && loggued_user_rol == 6) || (user_role_id == 2 && loggued_user_rol == 8)">
						    <b-tab title="User Details" active>
						    <b-row>
									<b-col md="8">
										<b-form-group :label-cols="4" horizontal label="Id" label-for="id" >
											<b-form-input class="plaintext-input" plaintext id="id" v-model="user_id" type="text"></b-form-input>
										</b-form-group>
										<b-form-group v-show="view" ghg :label-cols="4" id="L4" label="User Role:" label-for="RoleID" horizontal>
											<b-form-input v-show="!edit" class="plaintext-input" plaintext  v-model="user_role" type="text"></b-form-input>
											<b-form-select v-show="edit & userrolesselect.length>0" text-field="name" value-field="id" id="RoleID" v-model="user_role_id" :options="userrolesselect" @input="select_user_role()" />
										</b-form-group>

										<b-form-group v-show="view" v-if="showTC" :label-cols="4" id="L4" label="Trucking Company:" label-for="tcID" horizontal>
											<b-form-input v-show="!edit" class="plaintext-input" plaintext id="tcID" v-model="trucking_company_name" type="text"></b-form-input>
											<b-form-select v-show="edit & truckingcompanyselect.length>0" text-field="name" value-field="id" id="tcID" v-model="trucking_company_id" :options="truckingcompanyselect" @input="select_trucking_company()" />
										</b-form-group>

										<b-form-group label="Username:" label-for="Username" :label-cols="4" horizontal>
											<b-form-input v-show="!edit" class="plaintext-input" plaintext v-model="username" type="text" />
											<b-form-input v-show="edit" type="text" v-model="username" class="form-control" @keypress.native="isLowerCaseUsername($event)"/>
										</b-form-group>
										<b-form-group label="First Name:" label-for="FirstName" :label-cols="4" horizontal>
											<b-form-input v-show="!edit" class="plaintext-input" plaintext v-model="first_name" type="text" />
											<b-form-input v-show="edit" type="text" v-model="first_name" class="form-control" @keydown.native="isLetter($event)"/>
										</b-form-group>
										<b-form-group label="Last Name:" label-for="LastName" :label-cols="4" horizontal>
											<b-form-input v-show="!edit" class="plaintext-input" plaintext v-model="last_name" type="text" />
											<b-form-input v-show="edit" type="text" v-model="last_name" class="form-control" @keydown.native="isLetter($event)"/>
										</b-form-group>
										<b-form-group label="Email:" label-for="Email" :label-cols="4" horizontal>
											<b-form-input v-show="!edit" class="plaintext-input" plaintext v-model="email" type="text" />
											<b-form-input v-show="edit" type="email" v-model="email" class="form-control" @keypress.native="isLowerCaseEmail($event)"/>
										</b-form-group>
										<b-form-group v-if="showExtras" label="Phone:" label-for="phone" :label-cols="4" horizontal>
											<b-form-input v-show="!edit" class="plaintext-input" plaintext v-model="phone" type="text" />
											<b-form-input v-show="edit" v-mask="'##########'" v-model="phone" class="form-control" />
										</b-form-group>

										<b-form-group  v-if="showExtras" label="Terminal Boss ID:" label-for="TerminalBoss" :label-cols="4" horizontal>
											<b-form-input v-show="!edit" class="plaintext-input" plaintext v-model="terminal_boss_user_id" type="text" />
											<b-form-input autocomplete="off" v-show="edit" type="text" v-model="terminal_boss_user_id" class="form-control"/>
										</b-form-group>
										<!-- <b-form-group v-show="edit" label="Old Password:" label-for="oPassword" :label-cols="4" horizontal>
											<b-form-input type="password" v-model="old_password" class="form-control" />
										</b-form-group> -->
										<b-form-group v-show="edit" label="New Password:" label-for="nPassword" :label-cols="4" horizontal>
											<b-form-input id="nPassword" autocomplete="new-password" type="password" v-model="new_password" class="form-control" />
										</b-form-group>
										<b-form-group v-show="edit" label="Confirm new Password:" label-for="cnPassword" :label-cols="4" horizontal>
											<b-form-input id="cnPassword" autocomplete="new-password" type="password" v-model="confirm_new_password" class="form-control" />
										</b-form-group>

										<b-form-group v-show="view" v-if="energycompanyselect.length > 0 && showEC && edit" :label-cols="4" id="L4" label="Energy Companies:" label-for="ECID" horizontal>
											<b-form-radio-group text-field="name" value-field="id" class="custom-checkboxes" :options="energycompanyselect" name="radioSubComponent" plain v-model="energy_company_id"></b-form-radio-group>
										</b-form-group>
										<b-form-group v-if="operatingareasselect.length > 0 && showExtras && edit" :label-cols="4" id="L4" label="Operating Areas:" label-for="OAID" horizontal>
											<b-form-checkbox-group text-field="name" value-field="id" class="custom-checkboxes" :options="operatingareasselect" name="Checkboxes7" plain v-model="operating_areas_id" @input="operatingAreaChange"></b-form-checkbox-group>
											<b-form-checkbox style="margin-top: 15px;" v-model="oaAllSelected" :indeterminate="indeterminateOA" aria-describedby="" aria-controls="" plain @change="oaToggleAll">
												{{ oaAllSelected ? 'Un-select All' : 'Select All' }}
											</b-form-checkbox>
										</b-form-group>
										<b-form-group v-if="loadlocationsselect.length > 0 && showExtras && edit" :label-cols="4" id="L5" label="Load Locations:" label-for="LLID" horizontal>
											<b-form-checkbox-group plain disabled text-field="name" value-field="id" class="custom-checkboxes" :options="loadlocationsselect" name="Checkboxes6"  v-model="load_locations_id" ></b-form-checkbox-group>										</b-form-group>
										<b-form-group v-if="unloadlocationsselect.length > 0 && showExtras && edit" :label-cols="4" id="L6" label="Unload Locations:" label-for="ULID" horizontal>
											<b-form-checkbox-group plain disabled id="ULID" text-field="name" value-field="id" class="custom-checkboxes" :options="unloadlocationsselect" name="Checkboxes5" v-model="unload_locations_id" ></b-form-checkbox-group>
										</b-form-group>
										<b-form-group v-if="favorites_load_select.length > 0 && showExtras && edit" :label-cols="4" id="L20" label="Favorite Load Locations:" label-for="fav2" horizontal>
											<b-form-checkbox-group plain id="fav2" text-field="name" value-field="id" class="custom-checkboxes" :options="favorites_load_select" name="Checkboxes6" v-model="favorites_load_id" @input="llChange"></b-form-checkbox-group>
											<b-form-checkbox style="margin-top: 15px;" v-model="llAllSelected" :indeterminate="indeterminateLL" aria-describedby="" aria-controls="" plain @change="llToggleAll">
												{{ llAllSelected ? 'Un-select All' : 'Select All' }}
											</b-form-checkbox>
										</b-form-group>
										<b-form-group v-if="favorites_unload_select.length > 0 && showExtras && edit" :label-cols="4" id="L21" label="Favorite Unload Locations:" label-for="fav3" horizontal>
											<b-form-checkbox-group plain id="fav3" text-field="name" value-field="id" class="custom-checkboxes" :options="favorites_unload_select" name="Checkboxes5" v-model="favorites_unload_id" @input="ulChange"></b-form-checkbox-group>
											<b-form-checkbox style="margin-top: 15px;" v-model="ulAllSelected" :indeterminate="indeterminateUL" aria-describedby="" aria-controls="" plain @change="ulToggleAll">
												{{ ulAllSelected ? 'Un-select All' : 'Select All' }}
											</b-form-checkbox>
										</b-form-group>										

										<b-form-group v-if="showEC && !edit" :label-cols="4" id="L7" label="Energy Companies:" label-for="ECID" horizontal>
											<b-form-radio-group text-field="name" class="custom-checkboxes" :options="[energy_company_name]" name="Checkboxes2" v-model="energy_company_name" plain disabled></b-form-radio-group>
										</b-form-group>

										<b-form-group v-if="showExtras && !edit" :label-cols="4" id="L8" label="Operating Areas:" label-for="operationAreasID" horizontal>
											<b-form-checkbox-group text-field="name" class="custom-checkboxes" :options="operating_areas" name="Checkboxes2" plain :checked="allChecked('operating_areas')" disabled></b-form-checkbox-group>
										</b-form-group>
										<b-form-group v-if="showExtras && !edit" :label-cols="4" id="L9" label="Load Locations:" label-for="loadLocationsID" horizontal>
											<b-form-checkbox-group text-field="legal_location" class="custom-checkboxes" :options="load_locations" name="Checkboxes2" plain :checked="allChecked('load_locations')" disabled></b-form-checkbox-group>
										</b-form-group>
										<b-form-group v-if="showExtras && !edit" :label-cols="4" id="L10" label="Unload Locations:" label-for="operationAreasID" horizontal>
											<b-form-checkbox-group text-field="legal_location" class="custom-checkboxes" :options="unload_locations" name="Checkboxes2" plain :checked="allChecked('unload_locations')" disabled></b-form-checkbox-group>
										</b-form-group>
										<!-- Favoritos   -->	
										<b-form-group v-if="showExtras && !edit" :label-cols="4" id="L11" label="Favorite Load Locations" label-for="fav0" horizontal>
											<b-form-checkbox-group text-field="legal_location" class="custom-checkboxes" :options="favorites_load" name="Checkboxes2" plain :checked="allChecked('favorites_load')" disabled></b-form-checkbox-group>
										</b-form-group>	
										<b-form-group v-if="showExtras && !edit" :label-cols="4" id="L12" label="Favorite Unload Locations" label-for="fav1" horizontal>
											<b-form-checkbox-group text-field="legal_location" class="custom-checkboxes" :options="favorites_unload" name="Checkboxes2" plain :checked="allChecked('favorites_unload')" disabled></b-form-checkbox-group>
										</b-form-group>  
										<b-form-group label="Updated at" label-for="updated_at" :label-cols="4" horizontal>
											<b-form-input class="plaintext-input" plaintext id="updated_at" v-model="updated_at" type="text"></b-form-input>
										</b-form-group>
										<div slot="footer" v-show="edit">
											<b-button @click="updateUser" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
											<b-button  @click="editUser" size="sm" ><i class="fa fa-ban"></i> Cancel</b-button>
										<!-- <b-button v-b-popover.hover.top="'Delete this User?'" @click="deleteUser" size="sm" variant="danger"><i class="fa fa-trash"></i> Delete</b-button>  -->
										</div> 
									</b-col>
							</b-row>
						    </b-tab>
						    <b-tab title="Documents" >
						      	<b-row>
						      		<b-col md="12" lg="12" class="my-1">
										<b-button :disabled="loadingData" variant="primary" class="pull-right" @click=" newDocuments = true">Add New Document</b-button>
									</b-col>
									<b-col lg="12" md="12" class="my-1">
										<p class="text-danger" v-if="emptyFiles"><center> Not File found for this user</center></p>
										<b-table class="animated fadeIn" style="width: 100% !important;" v-else striped hover bordered show-empty stacked="md" :items="itemsFiles" :fields="fieldsFile" @row-clicked="rowClicked">
											<template slot="visor" slot-scope="row">
								                     <img :src="row.item.file" style="width: 40px; height: 40px;" alt="">
								            </template>
											<template slot="actions" slot-scope="row">
							                    <b-button size="sm" variant="danger" @click.stop="deleteDocument(row.item)">
							                      <i class="fa fa-trash"></i>
							                    </b-button>
							              </template>
										</b-table>
									</b-col>
						      	</b-row>
						    </b-tab>
						</b-tabs>
						 <!--b-tabs card v-model="tabIndex">
					      <b-tab title="Tab 1" :title-link-class="linkClass(0)">
					        Tab Contents 1
					      </b-tab>
					      <b-tab title="Tab 2" :title-link-class="linkClass(1)">
					        Tab Contents 2
					      </b-tab>
					      <b-tab title="Tab 3" :title-link-class="linkClass(2)">
					        Tab Contents 3
					      </b-tab>
					    </b-tabs-->
						<b-row v-else>
							<b-col md="8">
							<b-container>
								<b-form-group label="First Name" label-for="FirstName" :label-cols="4" horizontal>
									<b-form-input v-show="!edit" class="plaintext-input" plaintext v-model="first_name" type="text" />
									<b-form-input v-show="edit" type="text" v-model="first_name" class="form-control" @keydown.native="isLetter($event)"/>
								</b-form-group>
								<b-form-group label="Last Name" label-for="LastName" :label-cols="4" horizontal>
									<b-form-input v-show="!edit" class="plaintext-input" plaintext v-model="last_name" type="text" />
									<b-form-input v-show="edit" type="text" v-model="last_name" class="form-control" @keydown.native="isLetter($event)"/>
								</b-form-group>
								<b-form-group label="Username" label-for="Username" :label-cols="4" horizontal>
									<b-form-input v-show="!edit" class="plaintext-input" plaintext v-model="username" type="text" />
									<b-form-input v-show="edit" type="text" v-model="username" class="form-control" @keypress.native="isLowerCaseUsername($event)"/>
								</b-form-group>
								<b-form-group label="Email" label-for="Email" :label-cols="4" horizontal>
									<b-form-input v-show="!edit" class="plaintext-input" plaintext v-model="email" type="text" />
									<b-form-input v-show="edit" type="email" v-model="email" class="form-control" @keypress.native="isLowerCaseEmail($event)"/>
								</b-form-group>
								<b-form-group v-if="showExtras" label="phone" label-for="phone" :label-cols="4" horizontal>
									<b-form-input v-show="!edit" class="plaintext-input" plaintext v-model="phone" type="text" />
									<b-form-input v-show="edit" v-mask="'##########'" v-model="phone" class="form-control" />
								</b-form-group>
								<b-form-group v-show="role =='super_admin' || role =='operations_manager'" :label-cols="4" id="L4" label="User Role" label-for="RoleID" horizontal>
									<b-form-input v-show="!edit" class="plaintext-input" plaintext id="RoleID" v-model="user_role" type="text"></b-form-input>
									<b-form-select v-show="edit" text-field="name" value-field="id" id="RoleID" v-model="user_role_id" :options="userrolesselect" @input="select_user_role()" />
								</b-form-group>
								<b-form-group v-show="role =='super_admin' || role =='operations_manager'" v-if="showTC" :label-cols="4" id="L42" label="Trucking Company" label-for="tcID" horizontal>
									<b-form-input v-show="!edit" class="plaintext-input" plaintext id="tcID" v-model="trucking_company_name" type="text"></b-form-input>
									<b-form-select v-show="edit" text-field="name" value-field="id" id="tcID" v-model="trucking_company_id" :options="truckingcompanyselect" @input="select_trucking_company()" />
								</b-form-group>
								<b-form-group v-if="energycompanyselect.length > 0 && showEC && edit" :label-cols="4" v-show="view" id="L43" label="Energy Companies" label-for="ECID" horizontal>
									<b-form-radio-group text-field="name" value-field="id" class="custom-checkboxes" :options="energycompanyselect" name="radioSubComponent" plain v-model="energy_company_id" @input="select_energy_company()"></b-form-radio-group>
								</b-form-group>
								<b-form-group v-if="operatingareasselect.length > 0 && showExtras && edit" :label-cols="4" id="L5" label="Operating Areas" label-for="OAID" horizontal>
									<b-form-checkbox-group text-field="name" value-field="id" class="custom-checkboxes" :options="operatingareasselect" name="Checkboxes" plain v-model="operating_areas_id" @input="operatingAreaChange"></b-form-checkbox-group>
									<b-form-checkbox style="margin-top: 15px;" v-model="oaAllSelected" :indeterminate="indeterminateOA" aria-describedby="" aria-controls="" plain @change="oaToggleAll">
										{{ oaAllSelected ? 'Un-select All' : 'Select All' }}
									</b-form-checkbox>
								</b-form-group>

								<!--<b-form-group v-if="loadlocationsselect.length > 0 && showExtras && edit" :label-cols="4" id="L6" label="Load Locations" label-for="LLID" horizontal>
									<b-form-checkbox-group text-field="name" value-field="id" class="custom-checkboxes" :options="loadlocationsselect" name="Checkboxes" plain v-model="load_locations_id" @input="llChange"></b-form-checkbox-group>
									<b-form-checkbox style="margin-top: 15px;" v-model="llAllSelected" :indeterminate="indeterminateLL" aria-describedby="" aria-controls="" plain @change="llToggleAll">
										{{ llAllSelected ? 'Un-select All' : 'Select All' }}
									</b-form-checkbox>
								</b-form-group>
								<b-form-group v-if="unloadlocationsselect.length > 0 && showExtras && edit" :label-cols="4" id="L7" label="Unload Locations" label-for="ULID" horizontal>
									<b-form-checkbox-group text-field="name" value-field="id" class="custom-checkboxes" :options="unloadlocationsselect" name="Checkboxes" plain v-model="unload_locations_id" @input="ulChange"></b-form-checkbox-group>
									<b-form-checkbox style="margin-top: 15px;" v-model="ulAllSelected" :indeterminate="indeterminateUL" aria-describedby="" aria-controls="" plain @change="ulToggleAll">
										{{ ulAllSelected ? 'Un-select All' : 'Select All' }}
									</b-form-checkbox>
								</b-form-group> -->

								<b-form-group v-show="view" v-if="showEC && !edit" :label-cols="4" id="L8" label="Energy Companies" label-for="ECID" horizontal>
									<b-form-radio-group text-field="name" class="custom-checkboxes" :options="[energy_company_name]" name="Checkboxes2" v-model="energy_company_name" plain disabled></b-form-radio-group>
								</b-form-group>
								<b-form-group v-if="showExtras && !edit" :label-cols="4" id="L9" label="Operating Areas" label-for="operationAreasID" horizontal>
									<b-form-checkbox-group text-field="name" class="custom-checkboxes" :options="operating_areas" name="Checkboxes2" plain :checked="allChecked('operating_areas')" disabled></b-form-checkbox-group>
								</b-form-group>

								<b-form-group v-if="showExtras && !edit" :label-cols="4" id="L10" label="Load Locations" label-for="loadLocationsID" horizontal>
									<b-form-checkbox-group text-field="legal_location" class="custom-checkboxes" :options="load_locations" name="Checkboxes2" plain :checked="allChecked('load_locations')" disabled></b-form-checkbox-group>
								</b-form-group>
								<b-form-group v-if="showExtras && !edit" :label-cols="4" id="L11" label="Unload Locations" label-for="operationAreasID" horizontal>
									<b-form-checkbox-group text-field="legal_location" class="custom-checkboxes" :options="unload_locations" name="Checkboxes2" plain :checked="allChecked('unload_locations')" disabled></b-form-checkbox-group>
								</b-form-group>


								<b-form-group v-show="edit" label="New Password" label-for="nPassword" :label-cols="4" horizontal>
									<b-form-input id="nPassword" autocomplete="new-password" type="password" v-model="new_password" class="form-control" />
								</b-form-group>
								<b-form-group v-show="edit" label="Confirm new Password" label-for="cnPassword" :label-cols="4" horizontal>
									<b-form-input id="cnPassword" autocomplete="new-password" type="password" v-model="confirm_new_password" class="form-control" />
								</b-form-group>

							</b-container>

							<b-container v-if="current_user_role_name === 'analyst' || current_user_role_name === 'super_analyst' || current_user_role_name === 'marketing_accountant'"  >
								<b-row v-if="!edit">
										<b-col v-if="!operating_areas_access">
											<b-form-group v-if="operating_areas.length > 0" :label-cols="4" id="L4" label="Operating Areas" label-for="OAID" horizontal>
												<b-form-checkbox-group  text-field="name" value-field="id" class="custom-checkboxes" :options="operating_areas" name="Checkboxes" plain v-model="operating_areas_id" disabled></b-form-checkbox-group>
											</b-form-group>
										</b-col>
										<b-col v-else>
											<b-form-group :label-cols="4" id="L17" label="All Operating Areas Access" label-for="ULID" horizontal>
												<b-form-checkbox 
												id="checkbox"
																	class="custom-checkboxes"
																	style="margin-top: 13px;"
												v-model="operating_areas_access" 
																	disabled
												>
												</b-form-checkbox>					
											</b-form-group>
										</b-col>
								</b-row>
								<b-row v-else>
									<b-col>
										<b-form-group :label-cols="4" id="L17" label="All Operating Areas Access?" label-for="ULID" horizontal>
											<b-form-checkbox 
											id="checkbox"
																class="custom-checkboxes"
																style="margin-top: 13px;"
											v-model="operating_areas_access" 
											>
											</b-form-checkbox>					
										</b-form-group>
										<b-form-group v-if="operatingareasselect.length > 0 && !operating_areas_access" :label-cols="4" id="L4" label="Any Operating Areas?" label-for="OAID" horizontal>
											<b-form-checkbox-group  text-field="name" value-field="id" class="custom-checkboxes" style="margin-top: 13px;" :options="operatingareasselect" name="Checkboxes" plain v-model="operating_areas_id" @input="operatingAreaChange1"></b-form-checkbox-group>
										</b-form-group>
									</b-col>
								</b-row>
								<b-row v-if="!edit">
									<b-col v-if="energy_company_name==='Serafina Energy'">
										<b-form-group :label-cols="4" id="L18" label="Manage Intraday" label-for="checkbox1" horizontal>
											<b-form-checkbox 
												id="checkbox1"
												class="custom-checkboxes"
												style="margin-top: 13px;"
												v-model="manage_intraday" 
												disabled
											>
											</b-form-checkbox>					
										</b-form-group>
									</b-col>
								</b-row>
								<b-row v-else>
									<b-col v-if="energy_company_name==='Serafina Energy'">
										<b-form-group :label-cols="4" id="L18" label="Manage Intraday" label-for="checkbox1" horizontal>
											<b-form-checkbox 
												id="checkbox1"
												class="custom-checkboxes"
												style="margin-top: 13px;"
												v-model="manage_intraday" 
											>
											</b-form-checkbox>					
										</b-form-group>
									</b-col>
								</b-row>
							</b-container>

								<div slot="footer" v-show="edit">
									<b-button @click="updateUser" size="sm" variant="primary"><i class="fa fa-edit"></i>Update</b-button>
									<b-button  @click="editUser" size="sm" ><i class="fa fa-ban"></i>Cancel</b-button>
									<!-- <b-button v-b-popover.hover.top="'Delete this User?'" @click="deleteUser" size="sm" variant="danger"><i class="fa fa-trash"></i> Delete</b-button> -->
								</div>
							</b-col>
						</b-row>
				</b-card>
				<b-row v-else>
					<b-col cols="12" sm="12" md="12" lg="12">
						<br>
						<p class="text-center text-danger">
							<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
						</p>
					</b-col>
				</b-row>
			</div>
		</div>
		<!-- New Document Modal-->
	    <b-modal title="New Document" size="lg" ref="newDocuments" v-model="newDocuments" @hide="resetModal" hide-header-close no-close-on-backdrop no-close-on-esc>
	      <b-row>
	        	<b-col cols="12">
	        		<b-form-group :label-cols="4" horizontal label="Tittle" label-for="filetitle">
							<b-form-input id="" v-model="filetitle" type="text"></b-form-input>
						</b-form-group>
					<b-form-group :label-cols="4" horizontal label="Select File" label-for="filename">
						<b-form-file v-model="documents" accept="image/png, image/jpeg, image/jpg, application/pdf" class="mt-3" placeholder="Select File" plain></b-form-file>
  						<!--div class="mt-3">Selected documents:
  							<ul v-for="documento in documents">
  							<li> {{documento.name}}</li>
  						</ul></div-->
					</b-form-group>
	        	</b-col>
	      </b-row>
				<div slot="modal-footer" class="w-100">
					<b-btn size="md" variant="secondary" @click="newDocuments = false" class="float-left">Cancel</b-btn>
					<b-btn size="md" variant="primary" @click="saveDocuments" class="float-right">Upload</b-btn>
				</div>
	    </b-modal>
	    <!-- End New Document Modal-->
	</div>
</template>
<style>
.nav-pills > li{
	padding-right: 10px;
}
.nav-pills > li > a {
    color: #fff;
    background-color: #ffc107 !important;
}
</style>
<script>
	// ********** imports ************ //
	import users_service from './users_service'
	import roles_service from '../roles/roles_service'
	export default {
		name: 'user',
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		created: function() {
			this.getUserData()
		},
		data() {
			return {
				isSuperAnalyst: false,
				filetitle: '',
				documents: [],
				file: '',
				emptyFiles: true,
				itemsFiles: [],
				fieldsFile: [
					{
						key: 'comment',
						label: 'Title',
						sortable: true
					},
					{
						key: 'file_name',
						label: 'Document',
						sortable: true
					},
					{ key: 'actions', label: 'Actions' }
				],
				newDocuments: false,
				loggued_user_rol: localStorage.getItem('role_id'),
				edit: false,
				originalData: null,
				updateData: null,
				subTitle: '',
				tabIndex: 0,
				trucking_company_name: '',
				energy_company_name: '',
				operating_areas: [],
				load_locations: [],
				unload_locations: [],

				indeterminateOA: false,
				oaAllSelected: false,

				indeterminateLL: false,
				llAllSelected: false,
				indeterminateUL: false,
				ulAllSelected: false,

				user_role: '',
				current_user_role_name: '',
				insert_data: null,
				userrolesselect: [],
				energycompanyselect: [],
				truckingcompanyselect: [],
				loadlocationsselect: [],
				unloadlocationsselect: [],
				operatingareasselect: [],

				user_role_id: '',
				energy_company_id: 0,
				operating_areas_id: [],
				operating_areas_id_original: [],
				trucking_company_id: '',
				load_locations_id: [],
				unload_locations_id: [],
				username: '',
				first_name: '',
				last_name: '',
				email: '',
				phone: '',
				password: '',
				new_password: '',
				// old_password: '',
				confirm_new_password: '',

				showTC: false,
				showEC: false,
				showExtras: false,

				loadingData: true,
				found: false,
				notFoundMessage: 'Not found',
				role:'',
				view:true,
				view1:true,
				user_id:'',
				start:true,
				start1:true,
				new_load : [],
				terminal_boss_user_id:'',
				operating_areas_access		: true,
				checkbox_oa								: false,
				favorites_load_id    	: 	[],
				favorites_unload_id 	: 	[],
				favorites_load			: 	[],
				favorites_unload		:	[],
				favorites_load_select	:	[],
				favorites_unload_select :	[],
				Data_attr 				: 	[],
				manage_intraday			:   false,
				updated_at              : 	'',
			}
		},
		methods: {
			linkClass (idx) {
		      if (this.tabIndex === idx) {
		        return ['bg-primary', 'text-light']
		      } else {
		        return ['bg-primary', 'text-light']
		      }
		    },
			llChange(value) {
				// Wait for the v-model to update
				if (this.favorites_load_id.length !== 0) {
					if (this.favorites_load_id[0] == true) {
						this.favorites_load_id = []
						return
					}
				}

					if (this.favorites_load_id.length === 0) {
						this.indeterminateLL = false
						this.llAllSelected = false
					} else if (this.favorites_load_id.length === this.favorites_load_select.length) {
						this.indeterminateLL = false
						this.llAllSelected = true
					} else {
						this.indeterminateLL = true
						this.llAllSelected = false
					}
			},
			ulChange(value) {
				// Wait for the v-model to update
				if (this.favorites_unload_id.length !== 0) {
					if (this.favorites_unload_id[0] == true) {
						this.favorites_unload_id = []
						return
					}
				}
					if (this.favorites_unload_id.length === 0) {
						this.indeterminateUL = false
						this.ulAllSelected = false
					} else if (this.favorites_unload_id.length === this.favorites_unload_select.length) {
						this.indeterminateUL = false
						this.ulAllSelected = true
					} else {
						this.indeterminateUL = true
						this.ulAllSelected = false
					}
			},
			operatingAreaChange() {
				// Wait for the v-model to update
	
				if (!this.start) {
					let operating_area   		= this.operatingareasselect
					let operating_area_id   = this.operating_areas_id
					if (operating_area_id === true) {
						return
					}
					
					if (operating_area_id.length != 0) {
						if (operating_area_id[0] === true) {
							operating_area_id = []
							return
						}

						let ll = operating_area_id.map(item => {
							let oa_index = operating_area.map(o => o.id).indexOf(item)
							if (oa_index > -1) {
								return operating_area[oa_index].load_locations.map(o => o.id)
							}
						})

						let ul = operating_area_id.map(item => {
							let oa_index = operating_area.map(o => o.id).indexOf(item)
							if (oa_index > -1) {
								return operating_area[oa_index].unload_locations.map(o => o.id)
							}
						})
							this.load_locations_id 		= Array.prototype.concat.apply([], ll)
							this.unload_locations_id 	= Array.prototype.concat.apply([], ul)

					} else {
							operating_area 						= []
					    this.load_locations_id 		=	[] //this.arrayUnconcat(this.load_locations_id_original.concat(this.new_load))
							this.unload_locations_id	= []
					}
					// ---------------------
							// Favorites
							// load 
							let l_locations   		= this.loadlocationsselect
							let l_locations_id   = 	this.load_locations_id			
							let oa_ll = l_locations_id.map(item => {
									let oa_ll_index = l_locations.map(o => o.id).indexOf(item)
										if (oa_ll_index > -1) {
											return l_locations[oa_ll_index]
										}
							})
						  this.favorites_load_select = this.arrayUnique(oa_ll)	
						  this.favorites_load_id = []	
						 	// unload
							let ul_locations   		= this.unloadlocationsselect
							let ul_locations_id   = this.unload_locations_id				
							let oa_ul = ul_locations_id.map(item => {
								let oa_ul_index = ul_locations.map(o => o.id).indexOf(item)
									if (oa_ul_index > -1) {
									return ul_locations[oa_ul_index]
									}
							})
							this.favorites_unload_select = this.arrayUnique(oa_ul)
							this.favorites_unload_id = [] 
							// End			
							// ---------------------
						if (this.operating_areas_id.length === 0) {
							this.indeterminateOA 	= false
							this.oaAllSelected 		= false

						} else if (this.operating_areas_id.length === this.operatingareasselect.length) {
							this.indeterminateOA = false
							this.oaAllSelected 	 = true

						} else {
							this.indeterminateOA  = true
							this.oaAllSelected 		= false
						}
					
				} else {
						this.start=false
				}
			},
			oaToggleAll(checked) {
				this.operating_areas_id = checked ? this.operatingareasselect.map(item => {
					return item.id
					}) : []
			},
			llToggleAll(checked) {
				this.favorites_load_id = checked ? this.favorites_load_select.map(item => {
					return item.id
					}) : []
			},
			ulToggleAll(checked) {
				this.favorites_unload_id = checked ? this.favorites_unload_select.map(item => {
					return item.id
					}) : []
			},
			select_trucking_company() {
				let current_user_role_index = this.updateData.roles.map(o => o.id).indexOf(this.user_role_id)
				if (current_user_role_index > -1) {
					let current_user_role_name = this.updateData.roles[current_user_role_index].name.toLowerCase()
					if (current_user_role_name === 'driver') {
						let current_trucking_company_index = this.updateData.roles[current_user_role_index].trucking_companies.map(o => o.id).indexOf(this.trucking_company_id)
						if (current_trucking_company_index > -1) {
							let truckingcompany = this.updateData.roles[current_user_role_index].trucking_companies[current_trucking_company_index]
							this.unloadlocationsselect = truckingcompany.unload_locations
							this.unload_locations_id = []
							this.energycompanyselect = truckingcompany.energy_companies
							this.loadlocationsselect = truckingcompany.load_locations

							this.load_locations_id = []
							this.operatingareasselect = truckingcompany.operating_areas

							this.operating_areas_id = []

							this.indeterminateOA 	= false
							this.oaAllSelected 		= false
							this.indeterminateLL 	= false
							this.llAllSelected 		= false
							this.indeterminateUL 	= false
							this.ulAllSelected 		= false

						}
					}
				}
			},
			select_user_role() {
				//Get the user role name
				let current_user_role_index = this.updateData.roles.map(o => o.id).indexOf(this.user_role_id)
				if (current_user_role_index > -1) {
					this.current_user_role_name = this.updateData.roles[current_user_role_index].name.toLowerCase()
					if (this.current_user_role_name === 'operations_manager' || this.current_user_role_name === 'analyst' || this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'marketing_accountant') {
						let energycompanies = this.updateData.roles[current_user_role_index].energy_companies
						this.energycompanyselect = Array.isArray(energycompanies) ? [...energycompanies] : []
						this.showEC = true
						this.showTC = false
						this.showExtras = false
						this.energy_company_id = ''
						this.indeterminateEC = false
						this.ecAllSelected = false
					} else if (this.current_user_role_name === 'driver' || this.current_user_role_name === 'trucking_company_admin' || this.current_user_role_name === 'trucking_company_admin_light' || this.current_user_role_name === 'trucking_operational_manager') {
						let truckingcompanies = this.updateData.roles[current_user_role_index].trucking_companies
						this.truckingcompanyselect = Array.isArray(truckingcompanies) ? [...truckingcompanies] : []
						this.showTC = true
						this.showEC = false
						this.trucking_company_id = ''
						if (this.current_user_role_name === 'driver') {
							this.showExtras = true
							this.loadlocationsselect = []
							this.unloadlocationsselect = []
							this.load_locations_id = []
							this.unload_locations_id = []
							this.indeterminateOA = false
							this.oaAllSelected = false
							this.indeterminateLL = false
							this.llAllSelected = false
							this.indeterminateUL = false
							this.ulAllSelected = false
						} else {
							this.showExtras = false
						}
					} else {
						this.showEC = false
						this.showTC = false
						this.showExtras = false
					}

				}
			},
			allChecked(variable_name) {
				if (this[variable_name].length===0) {
					return
				} else {
					return Array(this[variable_name].length).fill(true)
				}							
			},
			setupFields() {

				let user_roles = this.updateData.roles
				this.userrolesselect = user_roles.map(item => {
					return {
						id: item.id,
						name: item.name.trim().replace(/_/g, " ").split(" ").map(function(item) {
							return item.charAt(0).toUpperCase() + item.slice(1)
						}).join(" ")
					}
				})

				let current_user_role_index = user_roles.map(o => o.id).indexOf(this.user_role_id)
				if (current_user_role_index > -1) {
					let current_user_role_name = user_roles[current_user_role_index].name.toLowerCase()
					if (current_user_role_name === 'driver' || current_user_role_name === 'trucking_company_admin' || current_user_role_name === 'trucking_company_admin_light' || current_user_role_name ==='trucking_operational_manager') {
						let current_trucking_company_index = user_roles[current_user_role_index].trucking_companies.map(o => o.id).indexOf(this.trucking_company_id)
						if (current_trucking_company_index > -1) {
							let truckingcompanies = user_roles[current_user_role_index].trucking_companies
							this.truckingcompanyselect = Array.isArray(truckingcompanies) ? [...truckingcompanies] : []
							this.showTC = true

							if(current_user_role_name === 'driver') {

								let truckingcompany 				= user_roles[current_user_role_index].trucking_companies[current_trucking_company_index]

								this.operatingareasselect 	= truckingcompany.operating_areas
								this.unloadlocationsselect 	= truckingcompany.unload_locations
								this.energycompanyselect 		= truckingcompany.energy_companies
								this.loadlocationsselect 		= truckingcompany.load_locations

								this.unload_locations_id 	= []
								this.load_locations_id 		= []
								this.operating_areas_id 	= []

								this.favorites_load_id 		= []

								this
								.showExtras = true
								this.indeterminateOA 	= false
								this.oaAllSelected 		= false
								this.indeterminateLL 	= false
								this.llAllSelected 		= false
								this.indeterminateUL 	= false
								this.ulAllSelected 		= false

								//Fill the preselected options
								if(this.originalData.operating_areas.length > 0) {
									this.operating_areas_id = this.originalData.operating_areas.map(item => {
										return item.id
									})
								}
								if(this.originalData.load_locations.length > 0) {
									this.load_locations_id = this.originalData.load_locations.map(item => {
										return item.id
									})
								}

								if(this.originalData.unload_locations.length > 0) {
									this.unload_locations_id = this.originalData.unload_locations.map(item => {
										return item.id
									})
								}

								if(this.originalData.favorites_load.length > 0) {
									this.favorites_load_id = this.originalData.favorites_load.map(item => {
										return item.id
									})
								}

								if(this.originalData.favorites_unload.length > 0) {
									this.favorites_unload_id = this.originalData.favorites_unload.map(item => {
										return item.id
									})
								}
								// Favorites
								// load 
								let l_locations   		= this.loadlocationsselect
								let l_locations_id   = 	this.load_locations_id
								let oa_ll = []				
								oa_ll = l_locations_id.map(item => {
									let oa_index = l_locations.map(o => o.id).indexOf(item)
									if (oa_index > -1) {
										return l_locations[oa_index]
									}
								})
								this.favorites_load_select = oa_ll
								// unload
								let ul_locations   		= this.unloadlocationsselect
								let ul_locations_id   = this.unload_locations_id				
								let oa_ul = ul_locations_id.map(item => {
								let oa_index = ul_locations.map(o => o.id).indexOf(item)
									if (oa_index > -1) {
										return ul_locations[oa_index]
									}
								})
								
								this.favorites_unload_select = this.arrayUnique(oa_ul)
								// End					
								// -----------------
								this.start=true
							}
						} else {
							let truckingcompanies = this.updateData.roles[current_user_role_index].trucking_companies
							this.truckingcompanyselect = Array.isArray(truckingcompanies) ? [...truckingcompanies] : []
							this.showTC = true
							this.showEC = false
							this.trucking_company_id = ''
							if (this.current_user_role_name === 'driver') {
								this.showExtras = true
								this.loadlocationsselect = []
								this.unloadlocationsselect = []
								this.load_locations_id = []
								this.unload_locations_id = []
								this.indeterminateOA = false
								this.oaAllSelected = false
								this.indeterminateLL = false
								this.llAllSelected = false
								this.indeterminateUL = false
								this.ulAllSelected = false
							} else {
								this.showExtras = false
							}							
						}
					//} else if(current_user_role_name === 'super_analyst') {
						//this.operating_areas_id = []
						//let energy_companies = user_roles[current_user_role_index].energy_companies
						//this.energycompanyselect = energy_companies
						//setTimeout(() => {
						//	this.energy_company_id = this.originalData.energy_company_id
						//	this.$forceUpdate()
						//}, 200)
					} else if(current_user_role_name === 'operations_manager' || current_user_role_name === 'marketing_accountant' || current_user_role_name === 'analyst' || current_user_role_name === 'super_analyst') {
							this.operating_areas_id = []
							let energy_companies = user_roles[current_user_role_index].energy_companies
							this.energycompanyselect = energy_companies
							setTimeout(() => {
							this.energy_company_id = this.originalData.energy_company_id
							this.$forceUpdate()
						}, 200)

						let ec_index = energy_companies.map(o => o.id).indexOf(this.energy_company_id)
							if (ec_index > -1) {
								this.operatingareasselect = energy_companies[ec_index].operating_areas
							}	

						let operating_areas_id= this.operating_areas_id
						let operating_areas = this.operating_areas
						if(operating_areas.length > 0) {
									operating_areas_id = operating_areas.map(item => {
										return item.id
									})
						}
						this.operating_areas_id = operating_areas_id 
						this.start1= true

					}
				 
				}

			},
			editUser() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.setupFields()
					this.edit = true
				}
			},
			restoreOriginalData() {
				this.user_id 				= this.originalData.id
				this.username 			= this.originalData.username
				this.first_name 		= this.originalData.first_name
				this.last_name 			= this.originalData.last_name
				this.email 					= this.originalData.email
				this.phone 					= this.originalData.phone
				this.terminal_boss_user_id	= this.originalData.terminal_boss_user_id
				this.new_password 	= ''
				// this.old_password = ''
				this.confirm_new_password = ''
				// this.password = this.originalData.password

				this.user_role_id 					= this.originalData.role_id
				this.current_user_role_name = this.originalData.role.toLowerCase()
				this.updated_at 					= this.originalData.updated_at 

				this.user_role = this.originalData.role.trim().replace(/_/g, " ").split(" ").map(function(item) {
					return item.charAt(0).toUpperCase() + item.slice(1)
				}).join(" ")

				if (this.originalData.trucking_company_name) {
					this.showTC 								= true
					this.trucking_company_name 	= this.originalData.trucking_company_name
					this.trucking_company_id 		= this.originalData.trucking_company_id
				}

				if (this.originalData.energy_company_name) {
						this.showEC = true
						this.energy_company_name = this.originalData.energy_company_name.trim().split(" ").map(function(item) {
						return item.charAt(0).toUpperCase() + item.slice(1)
					}).join(" ")
				}

				if(this.originalData.role == 'driver') {
					this.showExtras 			= true
					this.operating_areas 	= this.originalData.operating_areas
					this.load_locations 	= this.originalData.load_locations
					this.unload_locations = this.originalData.unload_locations
					this.favorites_load 	= this.originalData.favorites_load
					this.favorites_unload = this.originalData.favorites_unload
					var filesCount = this.originalData.files.length;
					if ( filesCount > 0) {
						this.emptyFiles = false
						this.itemsFiles = [];
						for( var i = 0; i < filesCount; i++){
							this.itemsFiles.push(this.originalData.files[i]);
						}
					}
				}

				if(this.originalData.role == 'operations_manager' || this.originalData.role == 'analyst' || this.originalData.role == 'super_analyst' || this.originalData.role == 'marketing_accountant') {
					this.energy_company_id = 0
					if (this.originalData.operating_areas==null) {
						this.operating_areas_access = true
					} else {
						this.operating_areas_access = false
						this.operating_areas_id = []
						this.operating_areas = []
						let operating_areas_id = []
						let operating_areas 	= this.originalData.operating_areas_sel
						this.operating_areas = operating_areas
						if(operating_areas.length > 0) {
									operating_areas_id = operating_areas.map(item => {
									return item.id
									})
						}
						this.operating_areas_id = operating_areas_id

						if (operating_areas_id.length != 0) {
								let ll = operating_areas_id.map(item => {
								let oa_index = operating_areas.map(o => o.id).indexOf(item)
								if (oa_index > -1) {
									return operating_areas[oa_index].load_locations.map(o => o.id)
								}
								})

								let ul = operating_areas_id.map(item => {
									let oa_index = operating_areas.map(o => o.id).indexOf(item)
										if (oa_index > -1) {
											return operating_areas[oa_index].unload_locations.map(o => o.id)
									}
								})
								this.load_locations_id 		= Array.prototype.concat.apply([], ll)
								this.unload_locations_id 	= Array.prototype.concat.apply([], ul)
							} else {
					    	this.load_locations_id 		=	[] //this.arrayUnconcat(this.load_locations_id_original.concat(this.new_load))
								this.unload_locations_id	= []
							}		

					}
					this.manage_intraday = this.originalData.manage_intraday			
				}
			},
			getUserData() {
				users_service.getBy(this.id)
					.then(data => {
						if (data[0] === 'success') {
							this.originalData = data[1]
							this.updateData = data[2]
							this.restoreOriginalData()
							this.subTitle = this.originalData.username.trim().replace(/_/g, " ").split(" ").map(function(item) {
								return item.charAt(0).toUpperCase() + item.slice(1)
							}).join(" ")

							this.found = true
							this.loadingData = false

							this.role = data[3]
							if (this.role =='super_admin') {
  									this.view=true
                  					this.view1=true
  							} else if (this.role =='operations_manager' || this.role =='marketing_accountant' || this.role =='super_analyst' || this.role =='analyst') {
  									this.view=false
                  					this.view1=false
  							} else if (this.role =='trucking_company_admin' || this.role =='trucking_company_admin_light' || this.role === 'trucking_operational_manager') {
                  					this.view=false
  									this.view1=true
             				}
							 this.getUpdateData()
						} else {
							this.items = []
							this.found = false
							this.loadingData = false
							this.$swal(data[0], data[1], data[0])
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
				if (this.user_role_id === undefined || this.user_role_id.length == 0) {
					this.$swal('Alert!', 'User Role not selected', 'warning')
					return false
				} else if (this.username === null || String(this.username).trim().length == 0) {
					this.$swal('Alert!', 'Username can not be empty', 'warning')
					return false
				} else if (this.first_name === null || String(this.first_name).trim().length == 0) {
					this.$swal('Alert!', 'First Name can not be empty', 'warning')
					return false
				} else if (this.last_name === null || String(this.last_name).trim().length == 0) {
					this.$swal('Alert!', 'Last Name can not be empty', 'warning')
					return false
				} 

				if(String(this.new_password).trim().length > 0 || String(this.confirm_new_password).trim().length > 0 ) {
					if (String(this.new_password).trim().length == 0 ) {
						this.$swal('Alert!', 'New Password can not be empty', 'warning')
						return false
					} else if (String(this.confirm_new_password).trim().length == 0 ) {
						this.$swal('Alert!', 'Confirm new Password can not be empty', 'warning')
						return false
					} else if(String(this.confirm_new_password).trim() !== String(this.new_password).trim()) {
						this.$swal('Alert!', 'New Password does not match the confirm password', 'warning')
						return false
					}
				}

				if(this.current_user_role_name === 'operations_manager' || this.current_user_role_name === 'marketing_accountant' || this.current_user_role_name === 'super_analyst') {
					if (this.energy_company_id === undefined || this.energy_company_id.length == 0) {
						this.$swal('Alert!', 'Energy Company not selected', 'warning')
						return false
					}
				} else if(this.current_user_role_name === 'driver' || this.current_user_role_name === 'trucking_company_admin' || this.current_user_role_name === 'trucking_company_admin_light' || this.current_user_role_name === 'trucking_operational_manager') {
					if (this.trucking_company_id === undefined || this.trucking_company_id.length == 0) {
						this.$swal('Alert!', 'Trucking Company not selected', 'warning')
						return false
					}
				}

				return true
			},
			updateUser() {
				if (!this.okToUpdate()) {
					return
				}

				let dataUser = {
						username				: this.username,
						email						: this.email,
						last_name				: this.last_name,
						first_name			: this.first_name,
						role_id					: this.user_role_id,
						// password: this.old_password,
				    new_password		: this.new_password,
     				new_new_password: this.confirm_new_password

				}
				if(this.current_user_role_name === 'operations_manager') {
					dataUser = {
						...dataUser,
						  energy_company_id		: this.energy_company_id,
							operating_areas_all : true,
							//load_locations			: this.load_locations_id,
							//unload_locations		: this.unload_locations_id,
							//operating_areas  		: this.operating_areas_id,
					}
				} else if(this.current_user_role_name === 'marketing_accountant' || this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'analyst') {
						dataUser = {
							...dataUser,
							energy_company_id		: this.energy_company_id,
							operating_areas_all 	: this.operating_areas_access,
							load_locations			: this.load_locations_id,
							unload_locations		: this.unload_locations_id,
							operating_areas  		: this.operating_areas_id,
							manage_intraday			: this.manage_intraday

						}
				} else if(this.current_user_role_name === 'driver') {
					Array.prototype.unique=function(a){
  						return function(){return this.filter(a)}}(function(a,b,c){return c.indexOf(a,b+1)<0
					});
					let load_locations_id=[]
					if (this.favorites_load_id.length!=0) {
						 load_locations_id=this.favorites_load_id.map(item => {
							return {
								id: String(item)
							}})
					}
					let unload_locations_id=[]
					if (this.favorites_unload_id.length!=0) {
						 unload_locations_id=this.favorites_unload_id.map(item => {
							return {
								id: String(item)
							}})
					}
					dataUser = {
						...dataUser,
						phone: this.phone,
						trucking_company_id : this.trucking_company_id,
						operating_areas  		: this.operating_areas_id.map(item => {
							return {
								id: String(item)
							}
						}),
						load_locations:  load_locations_id,
						unload_locations: unload_locations_id,
						terminal_boss_user_id : this.terminal_boss_user_id
					}
				} else if(this.current_user_role_name === 'trucking_company_admin' || this.current_user_role_name === 'trucking_company_admin_light' || this.current_user_role_name === 'trucking_operational_manager') {
					dataUser = {
						...dataUser,
						trucking_company_id: this.trucking_company_id
					}
				}
				users_service.update(this.id, dataUser)
					.then(data => {
						this.$swal(data[0], data[1], data[0])
							.then((result) => {
								if (data[0] == 'success') {
									this.loadingData = true
									this.found = false
									this.getUserData()
									this.edit = false
								}
							})
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})			
			},
			deleteUser() {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this User: " + this.username + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						users_service.delete(this.id)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.$router.replace('/users')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
			saveDocuments() {
				let userDocuments = [];
				if (this.documents == '') {
			    	this.$swal('Atention!', 'Please, select a file. ', 'warning')
			    } else {
					var extensionfile = this.documents.type.split('/')
					//alert(extensionfile[1])
					if (this.filetitle == '') {
				    	this.$swal('Atention!', 'Tittle must be not empty. ', 'warning')
				    } else if (this.documents.size > 2097152) {
				    	this.$swal('Atention!', 'Only files up to 2MB are allowed to upload. ', 'warning')
				    } else {
						if (extensionfile[1] == 'pdf' || extensionfile[1] == 'jpg' || extensionfile[1] == 'png' || extensionfile[1] == 'jpeg') {

							this.getFileReader( this.documents )
					    	.then( textFile => {
					    		var currentFile = {
							    	name: this.documents.name,
							    	comment: this.filetitle,
							    	file: textFile
							    }
					    		userDocuments.push(currentFile);
					    		//alert(JSON.stringify(userDocuments))
					    		let senDocuments = {
						    		documents: userDocuments
								    }
						        users_service.saveDocuments( senDocuments , this.id )
						    	.then(data => {
									this.$swal(data[0], data[1], data[0])
										.then((result) => {
											if (data[0] == 'success') {
												this.getUserData()
												this.newDocuments = false;
											}
										})
								})
								.catch(error => {
									this.$swal('Error', 'Server not response. ' + error, 'error')
								})
					    	})
					    } else {
					    	this.$swal('Atention!', 'Only the following extensions are allowed .png .jpg .jpge .pdf. ', 'warning')
					    }
				    }
				}
			},
			getFileReader( document ) {
				return new Promise((resolve, reject) => {
					var reader = new FileReader();
					reader.readAsDataURL(document)
					reader.onload = (e) => {
						var textFile = ""
				        textFile = e.target.result;
				        resolve(textFile)
				    };
				})
			},
			resetModal () {
		        this.documents = ''
		        this.filetitle = ''
		    },
		    deleteDocument ( item ) {
		    	this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Document: " + item.file_name + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						users_service.deleteDocument( item.id)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									//this.$router.replace('/users')
									this.getUserData()
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
		    },
		    rowClicked(row) {
		    	// got to -> user/:id/documents/:idDocument
				this.$router.push('/user/' + this.id + '/documents/' + row.id);
			},
			isLetter: function(evt) {
        		evt = (evt) ? evt : window.event;
        		var charCode = (evt.which) ? evt.which : evt.keyCode;
				var tecla = String.fromCharCode(charCode).toString();
				var letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
				 if(letras.indexOf(tecla) == -1){
					if ((charCode == 8) ||  (charCode == 9)) {
						return true
					} else {
						evt.preventDefault();
          			}
				 } else {
					return true
				 }
      		},
			isLowerCaseEmail: function(evt) {
				evt = (evt) ? evt : window.event;
        		var charCode = (evt.which) ? evt.which : evt.keyCode;
				if ((charCode >= 48 && charCode <= 57) || (charCode >= 97 && charCode <= 122)) {
					return true
				} else {
					if ((charCode == 45) || (charCode == 46) || (charCode == 64) || (charCode == 95) || (charCode == 8) ||  (charCode == 9)) {
						return true
					} else {
						evt.preventDefault();
          			}
				}
			  },
			isLowerCaseUsername: function(evt) {
				evt = (evt) ? evt : window.event;
        		var charCode = (evt.which) ? evt.which : evt.keyCode;
				if (charCode >= 97 && charCode <= 122) {
					return true
				} else {
					if ((charCode == 8) ||  (charCode == 9)) {
						return true
					} else {
						evt.preventDefault();
          			}
				}
			},
			resend() {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to send the Credentials ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						users_service.resend(this.id)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									let good='good'
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
      		},
			arrayUnique(array) {
    			var a = array.concat();
				let b=a
    			for(var i=0; i<a.length; ++i) {
        			for(var j=i+1; j<a.length; ++j) {
            			if(a[i].id === a[j].id)
                			b.splice(j--, 1);
        			}
    			}
    			return b;
			},
			select_energy_company() {
					if ((this.current_user_role_name === 'analyst' || this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'marketing_accountant') && this.energy_company_id!=0) {
						if (!this.start1) {
								this.operating_areas_id 	= []
								this.load_locations_id 		=	[] 
								this.unload_locations_id	= []
						} else {
								this.start1=false
						}			
							let energycompanies = this.energycompanyselect
							let energy_company_id = this.energy_company_id
							let ec_index = energycompanies.map(o => o.id).indexOf(energy_company_id)
							if (ec_index > -1) {
								this.operatingareasselect = energycompanies[ec_index].operating_areas
								this.energy_company_name  = energycompanies[ec_index].name
								if (this.energy_company_name==='Serafina Energy') {
									this.manage_intraday = this.originalData.manage_intraday
								} else {
									this.manage_intraday	  =   false
								}				
							}	 
					} 
			},
			operatingAreaChange1() {
				// Wait for the v-model to update
				// this.start = false
					let operating_area   		= this.operatingareasselect
					let operating_area_id   = this.operating_areas_id
					if (operating_area_id === true) {
						return
					}
					
					if (operating_area_id.length != 0) {
						let ll = operating_area_id.map(item => {
						let oa_index = operating_area.map(o => o.id).indexOf(item)
						if (oa_index > -1) {
							return operating_area[oa_index].load_locations.map(o => o.id)
						}
					})

					let ul = operating_area_id.map(item => {
						let oa_index = operating_area.map(o => o.id).indexOf(item)
						if (oa_index > -1) {
							return operating_area[oa_index].unload_locations.map(o => o.id)
						}
					})
							this.load_locations_id 		= Array.prototype.concat.apply([], ll)
							this.unload_locations_id 	= Array.prototype.concat.apply([], ul)
					} else {
							operating_area 						= []
					    this.load_locations_id 		=	[] 
							this.unload_locations_id	= []
					}
			},
			getUpdateData() {
				users_service.getAll3()
					.then(data => {
						if (data[0] === 'success') {
							this.updateData = data[1]
							if (this.edit) {
								this.setupFields()
							}							
						} else {
							this.$swal(data[0], data[1], data[0])
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/users/user.vue